export default __webpack_public_path__ + "static/media/UserManual.da433320.svg";